var React = require('react');

function NavIconsLosantLogo (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#111a2b;}")),React.createElement("title",{"key":1},"nav-icons_losant-logo"),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":2},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},React.createElement("path",{"d":"M27.45,0V0L19.56,8.63,11.32.38,0,11.72,11.64,23.31h0l8-8.64,8.17,8.17.21.21L39.25,11.68Zm0,6.12h0l5.7,5.58L27.91,17l-5.44-5.46ZM11.65,17.3h0L6.07,11.72l5.28-5.28,5.34,5.34ZM28,22.2l-8-8-2.9-2.9L11.35,5.58,5.22,11.72l5.83,5.83v4.31L.85,11.72,11.32,1.23l7.84,7.85L22.06,12l5.85,5.86L34,11.71,28,5.88V1.46L38.4,11.68Z"})))]);
}

NavIconsLosantLogo.defaultProps = {"viewBox":"0 0 39.25 23.31"};

module.exports = NavIconsLosantLogo;

NavIconsLosantLogo.default = NavIconsLosantLogo;
